import { render, staticRenderFns } from "./component-goods.vue?vue&type=template&id=45c06f07&"
import script from "./component-goods.vue?vue&type=script&lang=js&"
export * from "./component-goods.vue?vue&type=script&lang=js&"
import style0 from "./component-goods.vue?vue&type=style&index=0&id=45c06f07&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports